// extracted by mini-css-extract-plugin
export var header = "_hs-0";